import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, redirectingProfileEnum, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";
import { profileType } from "@utils/enum";
import { allCountryHighlightColumns } from "@utils/highLightColumnMultiCountry";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total Shipment Value (USD)", two_table_header: "Total Value (USD)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
];
export const defaultData = {
  name: "India Exports (Mirror)",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  isViewAllGridNew: true,
  isImpExpGraph: true,
  showUiTrends: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  minimumDateAllowed: "2020-01-01",
  isUIGridNew: true,
  isUEGridNew: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("intelSearchIndiaMirrorExportLatestArrivalDate"),
    getSearchResult: getApiUrl("intelSearchIndiaMirrorExport"),
    getAnalyticsData: getApiUrl("analytics/intelAnalyticsIndiaMirrorExport"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_india_mirror_exports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_india_mirror_exports"),
    getShipmentByID: getApiUrl("intelSearchIndiaMirrorExportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfIndiaExports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/intelAnalyticsIndiaMirrorExportViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("intelSearchIndiaMirrorExportGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.inmr_export.country_small,
  countryCaps: globalCountryDetails.inmr_export.country_caps,
  product_id: globalCountryDetails.inmr_export.product_id,
  compare_product_id: globalCountryDetails.inmr_export.compareProduct,
  country_CamelCase: globalCountryDetails.inmr_export.product_id,
  countryCode: globalCountryDetails.inmr_export.countryCode,
  countryType: globalCountryDetails.inmr_export.countryType,
  manyCountryType: globalCountryDetails.inmr_export.manyCountryType,
  countryTypeCode: globalCountryDetails.inmr_export.countryTypeCode,
  redirectionID: globalCountryDetails.inmr_export.redirectionID,
  analyticsCountryID: globalCountryDetails.inmr_export.analyticsCountryID,
  isMirror: globalCountryDetails.inmr_export.continent,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipment Date Range",
  monthRangeHeading: "Month of Import",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    ports: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.inmr_export.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortRegion",
    portOfUnlading: "standardUnladingPortRegion",
  },
  filterObj: {
    shipperName: "shipperName",
    isExporter: "isExporter",
    shipperStateRegion: "shipperStateRegion",
    shipperCityRegion: "shipperCityRegion",
    shipperZipcode: "shipperZipcode",
    consigneeName: "consigneeName",
    isImporter: "isImporter",
    countryOfDestinationRegion: "countryOfDestinationRegion",
    countryOfExportRegion: "countryOfExportRegion",
    inboundCountryRegion: "inboundCountryRegion",
    outboundCountryRegion: "outboundCountryRegion",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
    portOfLadingRegion: "portOfLadingRegion",
    portOfUnlading: "portOfUnlading",
    hsCode: "hsCode",
    shipmentValue: "shipmentValue",
    transportMode: "transportMode",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    derivedShipperMasterName: "derivedShipperMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    consigneeCountryRegion: "consigneeCountryRegion",
    standardLadingPortName: "standardLadingPortName",
    standardLadingPortRegion: "standardLadingPortRegion",
    standardUnladingPortName: "standardUnladingPortName",
    standardUnladingPortRegion: "standardUnladingPortRegion",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  booleanFilterObj: {
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    shipperStateRegion: "shipperState",
    shipperCityRegion: "shipperCity",
    outboundCountryRegion: "outboundCountry",
    inboundCountryRegion: "inboundCountry",
    countryOfDestinationRegion: "countryOfDestination",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
    countryOfExportRegion: "countryOfExport",
    portOfLadingRegion: "portOfLading",
    consigneeCountryRegion: "consigneeCountry",
    standardLadingPortRegion: "standardLadingPortName",
    standardUnladingPortRegion: "standardUnladingPortName",
  },
  emptyFilterObj: {
    shipperName: [],
    isExporter: [],
    shipperStateRegion: [],
    shipperCityRegion: [],
    shipperZipcode: [],
    consigneeName: [],
    isImporter: [],
    countryOfDestinationRegion: [],
    countryOfExportRegion: [],
    inboundCountryRegion: [],
    outboundCountryRegion: [],
    consigneeJurisdictionCountryRegion: [],
    shipperJurisdictionCountryRegion: [],
    consigneeCountryRegion: [],
    portOfLadingRegion: [],
    portOfUnlading: [],
    hsCode: [],
    sections: [],
    shipmentValue: [],
    transportMode: [],
    derivedConsigneeMasterName: [],
    derivedShipperMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    standardLadingPortRegion: [],
    standardUnladingPortRegion: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
  },
  defaultBooleanFilterObj: {
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    shipperName: false,
    isExporter: false,
    shipperStateRegion: false,
    shipperCityRegion: false,
    shipperZipcode: false,
    consigneeName: false,
    isImporter: false,
    countryOfDestinationRegion: false,
    countryOfExportRegion: false,
    inboundCountryRegion: false,
    outboundCountryRegion: false,
    consigneeJurisdictionCountryRegion: false,
    shipperJurisdictionCountryRegion: false,
    consigneeCountryRegion: false,
    portOfLadingRegion: false,
    portOfUnlading: false,
    hsCode: false,
    sections: false,
    shipmentValue: false,
    transportMode: false,
    derivedConsigneeMasterName: false,
    derivedShipperMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    standardLadingPortRegion: false,
    standardUnladingPortRegion: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Consignee Standardized Name", categoryName: "consigneeDetails", eventKey: "15", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Standardized Name", categoryName: "shipperDetails", eventKey: "16", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: "shipperDetails", eventKey: "1", key: "shipperName", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Name", categoryName: "consigneeDetails", eventKey: "6", key: "consigneeName", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search in Consignee Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Type", categoryName: "shipperDetails", eventKey: "2", key: "isExporter", type: filterType.normalFilter, label: "Shipper Type", viewAllPlaceHolder: "Search in Shipper Type Filter", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Shipper State", categoryName: "shipperDetails", eventKey: "3", key: "shipperStateRegion", altKey: "shipperState", type: filterType.localizeFilter, label: "Shipper State", viewAllPlaceHolder: "Search in Shipper State", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Shipper City", categoryName: "shipperDetails", eventKey: "4", key: "shipperCityRegion", altKey: "shipperCity", type: filterType.localizeFilter, label: "Shipper City", viewAllPlaceHolder: "Search in Shipper City Filter", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Shipper Pincode", categoryName: "shipperDetails", eventKey: "5", key: "shipperZipcode", type: filterType.normalFilter, label: "Shipper Pincode", viewAllPlaceHolder: "Search in Shipper Pincode Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Type", categoryName: "consigneeDetails", eventKey: "7", key: "isImporter", type: filterType.normalFilter, label: "Consignee Type", viewAllPlaceHolder: "Search in Consignee Type Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Jurisdiction Country", categoryName: "consigneeDetails", eventKey: "25", key: "consigneeJurisdictionCountryRegion", altKey: "consigneeJurisdictionCountry", type: filterType.localizeFilter, label: "Consignee Jurisdiction Country", viewAllPlaceHolder: "Search Consignee Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Jurisdiction Country", categoryName: "shipperDetails", eventKey: "25", key: "shipperJurisdictionCountryRegion", altKey: "shipperJurisdictionCountry", type: filterType.localizeFilter, label: "Shipper Jurisdiction Country", viewAllPlaceHolder: "Search Shipper Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Consignee Country", categoryName: "consigneeDetails", eventKey: "17", key: "consigneeCountryRegion", altKey: "consigneeCountry", type: filterType.localizeFilter, label: "Consignee Country", viewAllPlaceHolder: "Search in Consignee Country Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: "consigneeDetails", eventKey: "8", key: "inboundCountryRegion", altKey: "inboundCountry", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: "shipperDetails", eventKey: "8", key: "outboundCountryRegion", altKey: "outboundCountry", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port Of Lading", categoryName: "ports", eventKey: "9", key: "standardLadingPortRegion", altKey: "standardLadingPortName", type: filterType.localizeFilter, label: "Port Of Lading", viewAllPlaceHolder: "Search in Port Of Lading Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port Of Unlading", categoryName: "ports", eventKey: "10", key: "standardUnladingPortRegion", altKey: "standardUnladingPortName", type: filterType.localizeFilter, label: "Port Of Unlading", viewAllPlaceHolder: "Search in Port Of Unlading Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: "cargoDetails", eventKey: "9", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Type to Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: "cargoDetails", eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Type to Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: "cargoDetails", eventKey: "11", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipment Value", categoryName: "cargoDetails", eventKey: "13", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value (USD)", viewAllPlaceHolder: "Search in Value Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Mode of Transportation", categoryName: "freightType", eventKey: "14", key: "transportMode", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: "cargoDetails", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: false, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [...allCountryHighlightColumns],
  shipmentSorting: [
    { columnKey: "derived_shipping_bill_date", value: "date", isDefault: true },
    { columnKey: "derive_fob_value_usd", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
  ],
  importerSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
  ],
  sortKeyMap: {
    date: "derived_shipping_bill_date",
    shipment_value: "derive_fob_value_usd",
  },
  sortKeyUniqueImpExpMap: {
    shipment_value: "shipment_value",
    date: "doc_count",
  },
  analyticsHeaderItems: [
    { label: "Total Number of Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipment Value (USD)", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "mirror_trends", filterKey: "", label: "Export Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false, modalHeader: "Export Trends" },
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfExportRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "port_of_unlading", filterKey: "standardUnladingPortRegion", label: "Ports of Unlading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "port_of_lading", profileType: redirectingProfileEnum.portOfUnlading.key, isFavourite: true, profileTypeKey: profileType.ports },
    { key: "port_of_lading", filterKey: "standardLadingPortRegion", label: "Ports of Lading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "port_of_unlading", profileType: redirectingProfileEnum.portOfLading.key, isFavourite: true, profileTypeKey: profileType.ports },
    // { key: "country_of_destination", filterKey: "countryOfDestinationRegion", label: "Countries of Import", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "port_of_lading" },
    // { key: "shipper_state", filterKey: "shipperStateRegion", label: "Shipper States", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "country_of_destination" },
    // { key: "shipper_city", filterKey: "shipperCityRegion", label: "Shipper Cities", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "country_of_destination" },
    { key: "mode_of_transport", filterKey: "transportMode", label: "Modes of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "port_of_lading" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    // { key: "trade_route_lading_port_to_destination_country", filterKey1: "standardLadingPortRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Port of Lading → Country of Import)", headerOne: "Port of Lading", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwo: "field2Country", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "trade_route_lading_to_unlading", filterKey1: "standardLadingPortRegion", filterKey2: "standardUnladingPortRegion", label: "Trade Routes (Port of Lading → Port of Unlading)", headerOne: "Port of Lading", headerTwo: "Port of Unlading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwo: "field2Country", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "trade_route_lading_to_unlading_to_destination_country", filterKey1: "standardLadingPortRegion", filterKey2: "standardUnladingPortRegion", filterKey3: "countryOfDestinationRegion", label: "Trade Routes (Port of Lading → Port of Unlading → Country of Import)", filterOne: "filterField1", filterTwo: "filterField2", filterThree: "filterField3", headerOne: "Port Of Lading", headerTwo: "Port Of Unlading", headerThree: "Country of Import", keyOne: "field1Country", keyTwo: "field2Country", keyThree: "field3Country", cityOne: "field1", cityTwo: "field2", cityThree: "field3", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", keyThreeCountryCode: "field3CountryCode", type: analyticsType.topThree, grpType: "multi", showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    // { key: "trade_route_shipper_state_to_destination_country", filterKey1: "shipperStateRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Shipper State → Country of Import)", headerOne: "Shipper State", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwo: "field2Country", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, grow: 0, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "derived_shipping_bill_date", name: "Shipment Date", selector: "derived_shipping_bill_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_hs_code", name: "HS Code", selector: "derived_hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "product_description", name: "Product Description", selector: "product_description", tooltipValue: "product_description", type: "", grow: 2, wrap: true, isSliceEnabled: true, sliceLength: 30, miWidth: "120px", maWidth: "120px" },
    { key: "quantity", name: "Quantity", selector: "quantity", secondarySelector: "derived_quantity_unit", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "derived_consignee_master_name", name: "Consignee Name", selector: "derived_consignee_master_name", alternateSelector: "consignee_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "shipper_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_country_of_destination", name: "Country of Import", selector: "derived_country_of_destination", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derive_fob_value_usd", name: "Shipment Value (USD)", selector: "derive_fob_value_usd", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "140px", maWidth: "140px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    {
      key: "key",
      name: "Company Name",
      subProperties: [
        {
          className: "tw-bg-gray-200 tw-font-medium tw-border tw-rounded-[14px] tw-py-[3.2px] tw-px-2 tw-h-fit",
          selector: "iec_number",
        },
      ],
      selector: "key",
      selector1: "country",
      selector1Code: "country_code",
      selector2: "state",
      selector3: "address",
      id: "hashed_id",
      type: "companyRedirect",
      fixedLengthUptoRank: 30,
      fixedLengthUptoTrend: 28,
      minWidth: "275px",
    },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Shipment Date", value: "derived_shipping_bill_date", dateFormat: true, monthFormat: false },
        { label: "HS Code", value: "derived_hs_code" },
        // { label: "Invoice Number", value: "invoice_number" },
        // { label: "Item Number", value: "derived_item_number" },
        { label: "Mode of Transportation", value: "derived_mode_of_transport" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Port of Lading", value: "derived_port_of_lading", tooltip: true, tooltipField: "derived_port_of_lading_code", tooltipPrefix: "Port Code: ", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        // { label: 'Shipper ID', value: 'derived_shipper_iec_number', },
        { label: "Shipper Name", value: "shipper_name" },
        { label: "IEC Number", value: "derived_shipper_iec_number", preValidate: true, isIecField: true },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
        { label: "Shipper Type", value: "derived_is_exporter", tooltip: false, tooltipField: "" },
        { label: "Shipper State", value: "derived_shipper_state" },
        { label: "Shipper City", value: "derived_shipper_city" },
        { label: "Shipper Pincode", value: "derived_shipper_pin_code" },
        { label: "Shipper Address", value: "shipper_address", isReadMore: true, readMoreLength: 45 },
        { label: "Shipper Phone", value: "shipper_contact_number" },
        { label: "Shipper Email ID", value: "shipper_email_id" },
        { label: "Shipper Jurisdiction Country", value: "derived_shipper_jurisdiction_country", countryFlag: true, countryCodeField: "derived_shipper_jurisdiction_country_code" },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Port of Unlading", value: "derived_port_of_unlading", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code" },
        { label: "Consignee Name", value: "consignee_name" },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
        { label: "Consignee Type", value: "derived_is_importer" },
        { label: "Consignee Country", value: "derived_consignee_country" },
        { label: "Consignee Address", value: "consignee_address", isReadMore: true, readMoreLength: 45 },
        { label: "Consignee Jurisdiction Country", value: "derived_consignee_jurisdiction_country", countryFlag: true, countryCodeField: "derived_consignee_jurisdiction_country_code" },
      ],
    },
    // {
    //     id: 4,
    //     title: "Customs Details",
    //     growValue: 6,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
    //     data: [
    //         { label: 'Custom House Agent Code', value: 'derived_customs_house_agent_code', isCapitalise: true, },
    //         { label: 'Custom House Agent Name', value: 'customs_house_agent_name', isCapitalise: true, },
    //     ]
    // },
    // {
    //     id: 5,
    //     title: "Carrier Details",
    //     growValue: 6,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
    //     data: [
    //         { label: 'Vessel Name', value: 'vessel_name', isCapitalise: 'true', },
    //     ],
    // },
    {
      id: 4,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "HS Code", value: "derived_hs_code" },
        { label: "Product Description", value: "product_description" },
        { label: "Quantity", value: "quantity", dynamicUnit: true, unitField: "derived_quantity_unit", isCommaFormat: true },
        { label: "Shipment Value ", value: "derive_fob_value_usd", valuePrefix: "USD ", isCommaFormat: true, tooltip: true, tooltipField: "fob_value_inr", tooltipPrefix: "INR " },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
      ],
    },
  ],
  onboardingSteps: [
    { selector: "#reacttourdaterange", disableInteraction: true, header: "", description: "Customize your shipment basis payment date", float: "", position: "left" },
    { selector: "#reacttourFilter", disableInteraction: true, header: "Filters Button", description: "Use filters to get most relevant shipments for you", float: "right", position: "right" },
    { selector: "#reacttourMainSearch", disableInteraction: true, header: "Start searching for India Exports Shipments", description: "HS Codes and Consignees", float: "right", position: "bottom" },
    { selector: "#nav-tab", disableInteraction: true, header: "", description: "View unique consignees and shippers in the search result and add them to your prospect list.", float: "right", position: "bottom" },
    { selector: ".saved-search-button", disableInteraction: true, header: "", description: "Reload from Saved Searches, for quick shipments data access.", float: "", position: "bottom" },
  ],
  defaultUeUiSecondLevelKey: "derived_shipper_master_name",
  twoColumnMapping: {
    derived_consignee_master_name: "Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    // country_of_destination: "Countries of Import",
    port_of_unlading: "Ports of Unlading",
    port_of_lading: "Ports of Lading",
    // shipper_state: "Shipper States",
    // shipper_city: "Shipper Cities",
    mode_of_transport: "Mode of Transportation",
    // four_digit_hs_code: "4 Digit HS Codes",
    six_digit_hs_code: "6 digit HS Codes",
    // trade_route_lading_port_to_destination_country: "Trade Routes (Port of Lading → Country of Import)",
    // trade_route_lading_to_unlading: "Trade Routes (Port of Lading → Port of Unlading)",
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    // trade_route_lading_to_unlading_to_destination_country: "Trade Routes (Port Of Lading → Port of Unlading → Country of Import)",
    // trade_route_shipper_state_to_destination_country: "Trade Routes (Shipper State → Country of Import)",
  },
};

const IndiaExportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default IndiaExportSearch;
